/**
 * Impalcatura delle impostazioni: il sotto-menù a sinistra, la sezione scelta
 * a destra.
 *
 * Le sezioni sono **rotte annidate** e non uno stato interno alla pagina: così
 * `/impostazioni/posta` si può mandare a un collega o tenere nei segnalibri,
 * il tasto «indietro» del browser torna alla sezione precedente invece di
 * buttare fuori dalle impostazioni, e il menu del bollino in alto a destra può
 * puntare a una voce precisa.
 *
 * Qui dentro non c'è logica: il permesso, il titolo, l'elenco delle voci. Ogni
 * sezione si carica i propri dati per conto suo.
 */
import { NavLink, Outlet } from 'react-router-dom';

import { useAutenticazione } from '../../auth/contesto.tsx';
import { puoAmministrare } from '../../auth/ruoli.ts';

const VOCI = [
  { percorso: '/impostazioni/utenti', etichetta: 'Utenti' },
  { percorso: '/impostazioni/posta', etichetta: 'Server di posta' },
  { percorso: '/impostazioni/avvisi', etichetta: 'Avvisi automatici' },
  { percorso: '/impostazioni/aspetto', etichetta: 'Aspetto degli avvisi' },
  { percorso: '/impostazioni/allegati', etichetta: 'Allegati' },
  { percorso: '/impostazioni/aggiornamenti', etichetta: 'Aggiornamenti' },
];

export function Impostazioni() {
  const { utente } = useAutenticazione();

  // Nel menu del bollino la voce è già spenta per gli operatori, ma qui si può
  // arrivare con un indirizzo scritto a mano o preso dai segnalibri: il
  // backend risponderebbe 403 e si vedrebbe un errore tecnico invece di una
  // spiegazione.
  if (!puoAmministrare(utente?.ruolo)) {
    return (
      <>
        <div className="titolo-pagina"><h1>Impostazioni</h1></div>
        <div className="pannello">
          <p className="stato-vuoto">
            Questa sezione è riservata agli amministratori: da qui si danno e si tolgono
            gli accessi all'applicazione e si configura la casella di posta con cui
            vengono mandati gli avvisi.
          </p>
        </div>
      </>
    );
  }

  return (
    <div className="impianto-impostazioni">
      {/* Titolo e sotto-menu in un contenitore comune, ed è quello a restare
          ancorato mentre la pagina scorre — stesso schema di `.pagina-testa` in
          `App.tsx` e di `.dialogo-testa` in `Dialogo.tsx`.

          Il titolo stava fuori dalla griglia, sopra le due colonne: restava
          quindi l'unica cosa a scorrere via, e chi arrivava in fondo a una
          pagina lunga non aveva più niente a dirgli dove si trovava. Ancorarlo
          per conto suo avrebbe voluto dire scrivere a mano l'altezza dell'uno
          nel `top` dell'altro — cioè rifare il difetto appena chiuso. Un
          contenitore solo li tiene insieme senza nessun numero. */}
      <div className="colonna-impostazioni">
        <div className="titolo-pagina"><h1>Impostazioni</h1></div>

        <nav className="sotto-menu" aria-label="Sezioni delle impostazioni">
          {VOCI.map((v) => (
            <NavLink key={v.percorso} to={v.percorso}>{v.etichetta}</NavLink>
          ))}
        </nav>
      </div>

      <div className="sezione-impostazioni">
        <Outlet />
      </div>
    </div>
  );
}
